module.exports = __webpack_public_path__ + "img/HND.52605063.svg";